module.exports = __webpack_public_path__ + "static/media/asset-discovery.e5260218.svg";